module.exports = __webpack_public_path__ + "static/media/st anthonys logo.4c49eb47.png";